import React, { useState } from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../../../../contexts/LanguageContext"; 
import { Link } from "react-router-dom";

import imageOne from "../../../../assets/images/gifts-image-one.svg";
import imageTwo from "../../../../assets/images/gifts-image-two.svg";
import imageThree from "../../../../assets/images/gifts-image-three.svg";
import imageFour from "../../../../assets/images/gifts-image-four.svg";
import imageFive from "../../../../assets/images/gifts-image-five.svg";
import imageSix from "../../../../assets/images/gifts-image-six.svg";
import imageSeven from "../../../../assets/images/gifts-image-seven.svg";
import imageEight from "../../../../assets/images/gifts-image-eight.svg";
import imageNine from "../../../../assets/images/gifts-image-nine.svg";
import imageTen from "../../../../assets/images/gifts-image-ten.svg";
import imageEleven from "../../../../assets/images/gifts-image-two.svg";
import imageTwelve from "../../../../assets/images/gifts-image-eleven.svg";
import { gifts } from "../../../../utils/translations";
import useIsMobilei from "../../../../hooks/isMobile";
import "./gifts.css";

export default function Gifts() {
  const { language } = useLanguage(); 
  const { isMobilei } = useIsMobilei();

  const allImages = [
    imageOne, imageTwo, imageThree, imageFour, 
    imageFive, imageSix, imageSeven, imageEight, 
    imageNine, imageTen, imageEleven, imageTwelve
  ];

  const [currentGroup, setCurrentGroup] = useState(0);


  const handleNext = () => {
    if (currentGroup < Math.ceil(allImages.length / 4) - 1) {
      setCurrentGroup(currentGroup + 1);
    }
  };

  const handleBack = () => {
    if (currentGroup > 0) {
      setCurrentGroup(currentGroup - 1);
    }
  };

  const handleDragEnd = (event, info) => {
    if (info.offset.x < -50 && currentGroup < Math.ceil(allImages.length / 4) - 1) {
      setCurrentGroup(currentGroup + 1);
    } else if (info.offset.x > 50 && currentGroup > 0) {
      setCurrentGroup(currentGroup - 1);
    }
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px", marginTop: "80px" }}>
        <hr style={{ width: "50%", maxWidth: "500px", borderTop: "1px solid var(--secondary-color)" }} />
      </div>

      <div className={`gifts-header ${language === "ar" ? "rtl" : ""} ${language === "ar" ? "arab" : ""}`}>
        <h2 className="gifts-headerTitle">{gifts[language].gifts}</h2>
        <Link to="/see-all-gifts" className="gifts-headerLink">
          {gifts[language].seeAll}
        </Link>
      </div>

      {isMobilei ? (
        <motion.div 
          id="gifts-section"
          className="gifts-dragContainer"
          drag="x"
          dragConstraints={{ left: -5, right: 5 }} 
          onDragEnd={handleDragEnd}
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.1 }}
          transition={{ type: "spring", stiffness: 100, damping: 10 }} 
        >
          <div className="gifts-imagesContainer">
            {allImages.slice(currentGroup * 4, currentGroup * 4 + 4).map((image, index) => (
              <motion.img
                key={index}
                className="gifts-image"
                src={image}
                alt={`image${index + 1}`}
                whileTap={{ scale: 0.95 }}
              />
            ))}
          </div>
        </motion.div>
      ) : (
        <>
          <motion.div 
            id="gifts-section"
            className="gifts-imagesContainer"
            key={currentGroup}
            initial={{ opacity: 0, x: 500 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{duration : 0.3 }}
          >
            {allImages.slice(currentGroup * 4, currentGroup * 4 + 4).map((image, index) => (
              <motion.img 
                key={index} 
                className="gifts-image" 
                src={image} 
                alt={`image${index + 1}`} 
                whileTap={{ scale: 0.95 }}
              />
            ))}
          </motion.div>

          <div className={`gifts-buttonsContainer ${language === "ar" ? "rtl" : ""}`}>
            <p className="gifts-button" onClick={handleBack}>
              {gifts[language].back}
            </p>
            <p className="gifts-button" onClick={handleNext}>
              {gifts[language].next}
            </p>
          </div>
        </>
      )}
    </>
  );
}